module.exports = __webpack_public_path__ + "img/astral_10.b78baaa0.svg";